var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 21.6 24",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.805,6l1.584,4.671H16.8L13.015,13.34,14.6,18l-3.794-2.669L7.01,18l1.584-4.66L4.8,10.671H9.221ZM4.374,0,.579,4C4.227,7.207,0,10.223,0,14,0,16.8,3.536,22.6,10.8,24c7.264-1.4,10.8-7.2,10.8-10,0-3.774-4.236-6.79-.587-9.994l-3.8-4A12.552,12.552,0,0,1,10.8,1.716,12.586,12.586,0,0,1,4.374,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolice);
export default __webpack_public_path__ + "static/media/Police.13535bfd552504fd6482554d61dbd16a.svg";
export { ForwardRef as ReactComponent };